module.exports = __webpack_public_path__ + "static/1.2.B.7 CASA MERCEA - PLAN SUBSOL-f25e9de00b6b33385e8773bafc58f987.jpg";